import { useNavigate } from 'react-router-dom';

const difficultyStyles = {
  Easy:   'text-green-400 bg-green-400/10',
  Medium: 'text-yellow-400 bg-yellow-400/10',
  Hard:   'text-red-400 bg-red-400/10',
};

const languageStyles = {
  JavaScript: 'text-purple-300 bg-purple-300/10',
  Java:       'text-orange-300 bg-orange-300/10',
  SQL:        'text-blue-300 bg-blue-300/10',
};

const languageShort = {
  JavaScript: 'JS',
  Java: 'Java',
  SQL: 'SQL',
};

const ProblemCard = ({ problem, index }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/problem/${problem.id}`)}
      className="flex items-center gap-3 sm:gap-4 px-4 py-3.5 hover:bg-purple-950/20 cursor-pointer border-b border-gray-800/60 transition-colors group last:border-b-0"
    >
      {/* Index */}
      <span className="text-gray-600 text-xs w-7 text-right flex-shrink-0 font-mono">
        {String(index + 1).padStart(2, '0')}
      </span>

      {/* Title */}
      <span className="text-gray-200 font-medium flex-1 group-hover:text-white transition-colors text-sm sm:text-base truncate">
        {problem.title}
      </span>

      {/* Badges */}
      <div className="flex items-center gap-2 flex-shrink-0">
        <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${difficultyStyles[problem.difficulty]}`}>
          {problem.difficulty}
        </span>

        <div className="hidden md:flex gap-1.5">
          {problem.topics.slice(0, 2).map(topic => (
            <span key={topic} className="text-xs text-gray-600 bg-gray-800 px-2 py-0.5 rounded">
              {topic}
            </span>
          ))}
        </div>

        <span className={`hidden sm:inline text-xs font-medium px-2.5 py-1 rounded-full ${languageStyles[problem.language]}`}>
          {languageShort[problem.language]}
        </span>

        <svg className="w-4 h-4 text-gray-700 group-hover:text-purple-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </div>
  );
};

export default ProblemCard;
